
// This file was autogenerated by dynamically running setEnv.ts and using dotenv for managing API key secrecy

export const environment = {
  production: true,
  GOOGLE_API_KEY: 'AIzaSyC-OsKnSAcL41hUshFiaBL2YKjbs51k5Ks'
};
